import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { LifecycleService } from 'src/app/shared/services/lifecycle.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
export enum StateTypes {
  INITIAL = 'INITIAL',
  INTERMEDIATE = 'INTERMEDIATE',
  FINAL = 'FINAL'
}

export interface lifecycleStatepopupEditData{
  edata: any
}

@Component({
    selector: "app-life-cycle-pop-up",
    templateUrl: "./life-cycle-pop-up.component.html",
    styleUrls: ["./life-cycle-pop-up.component.scss"],
    standalone: false
})
export class LifeCyclePopUpComponent implements OnInit {
  validation_messages;
  // columnDefs;
  rowClassRules;
  defaultColDef;
  rowSelectionForTablesFields;
  rowSelection;

  paginationPageSize;

  paginationNumberFormatter;

  lastpage;

  currentpage;

  nextpage;

  nextpageplusone;

  totalpages;

  buttonIdList: any = [];
  pagesize;
  components: any;
  gridApi;
  backgroundColorScreen: any;
  buttonColor: any;
  rowData: any[] = [
    // { id: 1, name: "Item 1", status: "Yes" },
    // { id: 2, name: "Item 2", status: "No" },
    // { id: 3, name: "Item 3", status: "Yes" },
  ];
  columnDefs;
  buttonName;
  stateTypes = Object.values(StateTypes);
  lifecycleStatesrequestDto = {
    stateid: 0,
    statename: "",
    statetype: null as StateTypes | null,
    workflowcancelstate: "",
    sequenceorderstate: 0,

  };
  lifecycleRequestDto = {
    lifecycleid: 0,
    lifecyclename: "",
    description: "",
    objectname: "",
    states: [] as any[],
    defualtlifecycle: "false",
  };
  objects = [
    { value: "Object1", viewValue: "Object 1" },
    { value: "Object2", viewValue: "Object 2" },
    { value: "Object3", viewValue: "Object 3" },
  ];
  workflowCancelOptions: string[] = [
    "No state change",
    "State in which workflow started",
  ];
  validations_form: UntypedFormGroup;
  formValid: UntypedFormGroup;
  getRowStyle: (params: any) => { backgroundColor: string };
  columnDefinitionsForLifecycle = [];
  frameworkcomponent;
  checked = false;
  editingIndex: number | null = null;
  objectdetails: any;
  constructor(
    private localStorageSettings: LocalStorageSettingsService,
    private validation: validationmethod,
    private spinner: NgxUiLoaderService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    public dialogref: MatDialogRef<LifeCyclePopUpComponent>,
    private lifecycleservice: LifecycleService,
    @Inject(MAT_DIALOG_DATA) public data: lifecycleStatepopupEditData,
    private errorMessage: ErrorMessages,
  ) {
    this.validation_messages = this.errorMessage.lifecycle;
    this.components = {
      buttonRenderer: Actionbutton,
    };
  }
  /**
   * @Author Shyam
   * @Date 05/03/2026
   *  @Description: Lifecycle PopupComponent
   */
  ngOnInit(): void {
    if (this.data?.edata) {
      console.log(this.data.edata);

      this.lifecycleRequestDto = {
        ...this.data.edata,
        states:
          this.data.edata.states?.map((s,index) => ({
            stateid: s.stateid,
            statename: s.statename,
            statetype: s.statetype,
            workflowcancelstate: s.workflowcancelstate,
            sequenceorderstate: s.sequenceorderstate ?? index + 1
          })) || [],
      };
      this.buttonName = "Update";
      console.log(this.buttonName);
      if (this.lifecycleRequestDto.defualtlifecycle === "true") {
        this.checked = true;
      } else {
        this.checked = false;
      }
      this.rowData = [...(this.lifecycleRequestDto.states || [])];
      this.updateWorkflowCancelOptions();
    } else {
      this.buttonName = "Save";
    }
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      filter: true,
      sortable: true,
      resizable: true,
      
    };
    this.columnDefs = [
      {
    width: 50,
    rowDrag: true,
    sortable: false,
    filter: false,
    resizable: false,
    pinned: 'left',
    suppressMenu: true,
    cellRenderer: () => {
      const eDiv = document.createElement('div');
    eDiv.className = 'ag-drag-handle ag-row-drag';
    eDiv.innerHTML = `<span class="ag-icon ag-icon-grip"></span>`;
    return eDiv;
    }
  },
      {
        headerName: "Action",
        filter: false,
        cellRenderer: "buttonRenderer",
        pinned: "left",
        lockPinned: true,
        cellRendererParams: {
          values: this.buttonIdList,
          edit: this.editIcon.bind(this),
          delete: this.deleteIcon.bind(this),
        },
        width: 150,
      },
      {
        headerName: "State Name",
        headerTooltip: "State Name",
        tooltipValueGetter: (params) => "State Name : " + params.value,
        field: "statename",
        filter: "agTextColumnFilter",
        width: 200,
      },
      {
        headerName: "State Type",
        headerTooltip: "State Type",
        tooltipValueGetter: (params) => "State Type : " + params.value,
        field: "statetype",
        filter: "agTextColumnFilter",
        width: 200,
      },
      {
        headerName: "Workflow Cancel State",
        headerTooltip: "Workflow Cancel State",
        tooltipValueGetter: (params) =>
          "Workflow Cancel State : " + params.value,
        field: "workflowcancelstate",
        filter: "agTextColumnFilter",
        width: 250,
      },
    ];
    this.formValidation();
    this.formValidationforState();
    this.backgroundColorScreen =
      this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
  }

  formValidation() {
    this.validations_form = new UntypedFormGroup({
      lifecyclename: new FormControl("", [
        Validators.required,
        this.validation.specialCharacterValidator,
        this.validation.noWhitespaceValidator,
      ]),
      description: new FormControl(""),
      objectname: new FormControl(""),
      defualtlifecycle: new FormControl(false),
    });
  }
  formValidationforState() {
    this.formValid = new UntypedFormGroup({
      statename: new FormControl("", Validators.required),
      statetype: new FormControl("", Validators.required),
      workflowcancelstate: new FormControl("", Validators.required),
    });
  }

  onBtExport() {
    this.gridApi.api.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridApi.api) {
      this.lastpage = this.gridApi.api.paginationIsLastPageFound();
      this.currentpage = this.gridApi.api.paginationGetCurrentPage() + 1;
      this.nextpage = this.gridApi.api.paginationGetCurrentPage() + 1 + 1;
      this.nextpageplusone =
        this.gridApi.api.paginationGetCurrentPage() + 1 + 1 + 1;
      this.totalpages = this.gridApi.api.paginationGetTotalPages();
    }
  }
  //this function is for going to the given page number
  onSearchChange(searchValue: number) {
    this.gridApi.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pagesize;
    this.gridApi.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next");
    this.gridApi.api.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous");
    this.gridApi.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    console.log("first");
    this.gridApi.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    console.log("last");
    this.gridApi.api.paginationGoToLastPage();
  }
  onGridReady(params) {
    this.gridApi = params;
    params.api.setGridOption('rowData', []);
    // this.gridApi.api.setGridOption('rowData', this.lifecycleRequestDto?.states || []);
      const sortedData = (this.lifecycleRequestDto?.states || [])
    .sort((a, b) => a.sequenceorderstate - b.sequenceorderstate);

  this.gridApi.api.setGridOption('rowData', sortedData);

  //  Apply grid sort (optional safety)
  this.gridApi.api.setSortModel([
    { colId: 'sequenceorderstate', sort: 'asc' }
  ]);
  }
  onObjectChange(event) {
    console.log(event);
    this.lifecycleRequestDto.objectname = event.value;
    //  this.lifecycleRequestDto.objectname = JSON.stringify(event.value);
  }

  onWorkFlowCancelState(event) {
    console.log(event.value);
    this.lifecycleStatesrequestDto.workflowcancelstate = event.value;
  }
  addState() {
    if (this.formValid.invalid) {
      this.formValid.markAllAsTouched();
      //  this.validation.validateAllFormFields(this.formValid);
      //  this.validation.getvalidationmessage();
      return;
    }
    const { statename, statetype, workflowcancelstate } =
      this.lifecycleStatesrequestDto;

    //  Check existing types
    const hasInitial = this.lifecycleRequestDto.states.some(
      (state) => state.statetype === StateTypes.INITIAL,
    );

    const hasFinal = this.lifecycleRequestDto.states.some(
      (state) => state.statetype === StateTypes.FINAL,
    );

    if (statetype === StateTypes.INITIAL && hasInitial) {
      this.snackbar.open("Only one Initial state is allowed", "Close", {
        duration: 3000,
      });
      return;
    }

    if (statetype === StateTypes.FINAL && hasFinal) {
      this.snackbar.open("Only one Final state is allowed", "Close", {
        duration: 3000,
      });
      return;
    }
    if (statename.trim() === "" || statetype.trim() === "") {
      this.snackbar.open("State Name and State Type cannot be empty", "Close", {
        duration: 3000,
      });
      return;
    }
    const isDuplicateName = this.lifecycleRequestDto.states.some(
      (state) => state.statename.toLowerCase() === statename.toLowerCase(),
    );

    if (isDuplicateName) {
      this.snackbar.open("Duplicate State Name is not allowed", "Close", {
        duration: 3000,
      });
      return;
    }

    const newState = {
      stateid: this.lifecycleStatesrequestDto.stateid || 0,
      statename,
      statetype,
      workflowcancelstate: workflowcancelstate || null,
      sequenceorderstate: this.lifecycleRequestDto.states.length + 1
    };

    if (this.editingIndex !== null) {
      this.lifecycleRequestDto.states.splice(this.editingIndex, 0, newState);
      this.editingIndex = null;
    } else {
      this.lifecycleRequestDto.states.push(newState);
    }

    this.rowData = [...this.lifecycleRequestDto.states];
    this.updateWorkflowCancelOptions();

    this.lifecycleStatesrequestDto = {
      stateid: 0,
      statename: "",
      statetype: null as StateTypes | null,
      workflowcancelstate: "",
      sequenceorderstate: 0
    };
  }
  onSubmit() {
    this.spinner.start();
    if (!this.validations_form.valid) {
      // displaying validation messages
      this.validation.validateAllFormFields(this.validations_form);

      this.validation.getvalidationmessage();
      this.spinner.stop();
      return;
    } else {
      this.lifecycleRequestDto.lifecyclename =
        this.validations_form.value.lifecyclename;
      this.lifecycleRequestDto.description =
        this.validations_form.value.description;
      this.lifecycleRequestDto.objectname = JSON.stringify(
        this.validations_form.value.objectname,
      );
      this.lifecycleRequestDto.defualtlifecycle = this.checked
        ? "true"
        : "false";
      this.lifecycleRequestDto.states = this.lifecycleRequestDto.states.map(
        (state) => ({
          stateid: state.stateid ?? 0,
          statename: state.statename,
          statetype: state.statetype,
          workflowcancelstate: state.workflowcancelstate,
           sequenceorderstate: state.sequenceorderstate
        }),
      );
      // this.lifecycleRequestDto.states
      if (
        !this.lifecycleRequestDto.states ||
        this.lifecycleRequestDto.states.length === 0
      ) {
        this.addDefaultStates();
      }

      const initialCount = this.lifecycleRequestDto.states.filter(
        (states) => states.statetype === StateTypes.INITIAL,
      ).length;
      const finalCount = this.lifecycleRequestDto.states.filter(
        (states) => states.statetype === StateTypes.FINAL,
      ).length;

      if (initialCount !== 1 || finalCount !== 1) {
        this.snackbar.open(
          "Lifecycle must have exactly one Initial and one Final state.",
          "Close",
          { duration: 3000 },
        );
        this.spinner.stop();
        return;
      }

      console.log(this.lifecycleRequestDto);
      this.lifecycleservice
        .createLifecycle(this.lifecycleRequestDto)
        .subscribe((response) => {
          console.log(response);
          this.spinner.stop();
          this.snackbar.open(response.statusMessage, "OK", { duration: 3000 });
          this.onCancel();
          this.dialogref.close(response.data);
        });
    }
  }

  onCancel() {
    this.validations_form.reset();
    this.buttonName = "Save";
    this.lifecycleRequestDto = {
      lifecycleid: 0,
      lifecyclename: "",
      description: "",
      objectname: "",
      states: [] as any[],
      defualtlifecycle: "false",
    };
    this.lifecycleStatesrequestDto = {
      stateid: 0,
      statename: "",
      statetype: null as StateTypes | null,
      workflowcancelstate: "",
      sequenceorderstate: 0
    };
    this.dialogref.close();
  }

  onDefaultFilterChange() {
    console.log(this.checked);
    if (this.checked) {
      this.lifecycleRequestDto.defualtlifecycle = "true";
    } else {
      this.lifecycleRequestDto.defualtlifecycle = "false";
    }
  }

  editIcon(params) {
    const row = params.rowData;

    // find index in array
    const index = this.lifecycleRequestDto.states.findIndex(
      (state) =>
        state.statename === row.statename && state.statetype === row.statetype,
    );

    if (index !== -1) {
      // store editing index
      this.editingIndex = index;

      // populate form
      this.lifecycleStatesrequestDto = {
        stateid: row.stateid,
        statename: row.statename,
        statetype: row.statetype,
        workflowcancelstate: row.workflowcancelstate ?? "",
        sequenceorderstate: row.sequenceorderstate

      };

      // remove temporarily from array
      this.lifecycleRequestDto.states.splice(index, 1);

      // refresh grid
      this.rowData = [...this.lifecycleRequestDto.states];
      this.updateWorkflowCancelOptions();
    }
  }

  deleteIcon(params) {
    console.log(params);
    console.log(this.lifecycleRequestDto.states);
    const index = this.lifecycleRequestDto.states.findIndex(
      (state) =>
        state.statename === params.rowData.statename &&
        state.statetype === params.rowData.statetype,
    );
    if (index !== -1) {
      this.lifecycleRequestDto.states.splice(index, 1);
      this.rowData = [...this.lifecycleRequestDto.states];
      this.updateWorkflowCancelOptions();
    }
  }

  updateWorkflowCancelOptions() {
    if (this.lifecycleRequestDto.states.length === 0) {
      this.workflowCancelOptions = [
        "No state change",
        "State in which workflow started",
      ];
      return;
    }

    const stateNames = this.lifecycleRequestDto.states.map(
      (state) => state.statename,
    );

    this.workflowCancelOptions = [
      "No state change",
      "State in which workflow started",
      ...stateNames,
    ];
  }

  addDefaultStates() {
    this.lifecycleRequestDto.states = [
      {
        stateid: 0,
        statename: "Submit",
        statetype: StateTypes.FINAL,
        workflowcancelstate: "State in which workflow started",
          sequenceorderstate: 2
      },
      {
        stateid: 0,
        statename: "Approve",
        statetype: StateTypes.INITIAL,
        workflowcancelstate: "State in which workflow started",
          sequenceorderstate: 1
      },
    ];
  }

 onRowDragEnd(event: any) {
  let list: any[] = [];

  this.gridApi.api.forEachNodeAfterFilterAndSort((node) => {
    list.push(node.data);
  });

  // separate FINAL
  const finalState = list.find(x => x.statetype === StateTypes.FINAL);
  const others = list.filter(x => x.statetype !== StateTypes.FINAL);

  const ordered = [...others, finalState];

  // assign sequence
  ordered.forEach((state, index) => {
    state.sequenceorderstate = index + 1;
  });

  this.lifecycleRequestDto.states = ordered;
  this.rowData = [...ordered];
}
}
